import { PlayerEloStatPreviewWidget } from '@features/user/ui/PlayerEloStatsPreview/PlayerEloStatPreview';
import { SomePlayerGamesListWidget } from '@features/user/ui/SomePlayerGamesList/SomePlayerGamesListWidget';
import { SomePlayerStats } from '@features/user/ui/SomePlayerStats/SomePlayerStats';

type Props = {
  userId: string;
};
export function SomePlayerStatsWidget({ userId }: Props) {
  return (
    <SomePlayerStats>
      <PlayerEloStatPreviewWidget clockControlType="Bullet" userId={userId} />
      <PlayerEloStatPreviewWidget clockControlType="Blitz" userId={userId} />
      <PlayerEloStatPreviewWidget clockControlType="Rapid" userId={userId} />

      <SomePlayerGamesListWidget userId={userId} />
    </SomePlayerStats>
  );
}
